import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => (
  <div className="scientia-container">
    <div className="error-page">
      <div className="error-content">
        <div className="error-icon">🔍</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="error-actions">
          <Link to="/" className="button is-primary">Go Home</Link>
          <Link to="/chat" className="button is-outlined">Try Chat</Link>
        </div>
      </div>
    </div>
  </div>
);

export default NotFound;
